module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.enabled) ? _c('button', {
    ref: "btn",
    class: ['dg-btn', 'dg-btn--ok', {
      'dg-btn--loading': _vm.loading
    }, {
      'dg-pull-right': !_vm.options.reverse
    }],
    attrs: {
      "disabled": _vm.is_disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.proceed()
      }
    }
  }, [_c('span', {
    staticClass: "dg-btn-content"
  }, [_vm._t("default"), _vm._v(" "), (_vm.soft_confirm) ? _c('span', [_vm._v("(" + _vm._s(_vm.clicks_remaining) + ")")]) : _vm._e()], 2), _vm._v(" "), (_vm.loading) ? _c("btn-loader", {
    tag: "span"
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-424ea784!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/components/ok-btn.vue
// module id = 64
// module chunks = 0